const siteMetadata = {
  appName: "ON Live TV",
  title: "ON Live TV - eSports, thể thao, giải trí hàng đầu Việt Nam",
  author: "VTV Live",
  headerTitle: "DeFi for home",
  description:
    "ON Live TV - trọn vẹn luồng cảm xúc CKTG. Kho nội dung Esports, thể thao và giải trí đa dạng hàng đầu Việt Nam.",
  siteLogo: "/siteLogo.png",
  siteUrl: "onlivetv.vn",
  theme: "light", // system, dark or light
  thumb: "/siteThumb.png"
}

export default siteMetadata
